import DiverseEmojisOptions from './store/schema/options/DiverseEmojisOptions';
import SkypeNotificationOptions from './store/schema/options/SkypeNotificationOptions';
import SmartSuggestionsOptions from './store/schema/options/SmartSuggestionsOptions';
import SurfaceActionsOptions, {
    ComposeActionKey,
    ReadActionKey,
    HoverActionKey,
    ActionKey,
} from './store/schema/options/SurfaceActionsOptions';
import WebPushNotificationsOptions from './store/schema/options/WebPushNotificationsOptions';
import ConfettiOptions from './store/schema/options/ConfettiOptions';
import ComposeAssistanceOptions from './store/schema/options/ComposeAssistanceOptions';
import GdprAdsPrefsOptions from './store/schema/options/GdprAdsPrefsOptions';
import OwsOptionsBase from './store/schema/OwsOptionsBase';
import OwsOptionsResponse from './service/OwsOptionsResponse';
import { OwsOptionsFeatureType } from './store/schema/OwsOptionsFeatureType';
import AddinPinModes from './utils/AddinPinModes';
import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import CalendarSurfaceAddinsOptions from './store/schema/options/CalendarSurfaceAddinsOptions';
import ExternalImagesOptions from './store/schema/options/ExternalImagesOptions';
import EventCaptureOptions from './store/schema/options/EventCaptureOptions';
import LinkedInBindingDismissedOptions from './store/schema/options/LinkedInBindingDismissedOptions';
import TranslationOptions from './store/schema/options/TranslationOptions';
import CalendarSurfaceOptions from './store/schema/options/CalendarSurfaceOptions';
import TxpEventNotificationsOptions from './store/schema/options/TxpEventNotificationsOptions';
import MentionEventNotificationsOptions from './store/schema/options/MentionEventNotificationsOptions';
import AmpDeveloperOptions from './store/schema/options/AmpDeveloperOptions';
import ActivityFeedOptions from './store/schema/options/ActivityFeedOptions';
import { ActivityFeedWebSurfaceOptions } from './store/schema/options/ActivityFeedOptions';
// import mutators
import './mutators/applyDefaultOptionsOnLoadFail';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "OutlookServiceOptions" */ './lazyIndex')
);

export let lazyCreateOrUpdateOptionsForFeature = new LazyAction(
    lazyModule,
    m => m.createOrUpdateOptionsForFeature
);

export let lazyUpdateAddinPinStatus = new LazyAction(lazyModule, m => m.updateAddinPinStatus);

// Synchronous exports
export { default as getOptionsForFeature } from './selectors/getOptionsForFeature';
export { default as getDefaultOptions } from './data/defaultOptions';
export {
    AddinPinModes,
    OwsOptionsFeatureType,
    OwsOptionsBase,
    SmartSuggestionsOptions,
    DiverseEmojisOptions,
    SurfaceActionsOptions,
    ComposeActionKey,
    ReadActionKey,
    HoverActionKey,
    ActionKey,
    SkypeNotificationOptions,
    WebPushNotificationsOptions,
    OwsOptionsResponse,
    ConfettiOptions,
    ComposeAssistanceOptions,
    GdprAdsPrefsOptions,
    CalendarSurfaceAddinsOptions,
    ExternalImagesOptions,
    EventCaptureOptions,
    LinkedInBindingDismissedOptions,
    TranslationOptions,
    CalendarSurfaceOptions,
    TxpEventNotificationsOptions,
    MentionEventNotificationsOptions,
    AmpDeveloperOptions,
    ActivityFeedOptions,
    ActivityFeedWebSurfaceOptions,
};

export const lazyGetServerOptionsForFeature = new LazyImport(
    lazyModule,
    m => m.getServerOptionsForFeature
);

// Load the options after bootstrap
// We may, in the future, move this to bootstrap and block boot on its resolution
//
// 'loadOptions' will be called by the following
// 'runAfterInitialRender'. It returns a promise, so if any consumer wants
// to act after this is completed, it can wait on its completion and do work
export let lazyLoadOptions = new LazyAction(lazyModule, m => m.loadOptions);

runAfterInitialRender(() => {
    lazyLoadOptions.importAndExecute();
});
